<ng-container *ngFor="let row of statistic | pairs">
  <div *ngIf="row[0] !== 'ProcessingLogRecords'" class="stat-block">
    <mat-card-subtitle>{{ row[0] }}</mat-card-subtitle>

    <ul class="statistic-list">
      <li *ngFor="let item of normalizeStatisticValue(row[1])">
        <span class="name" *ngIf="item.key">{{ item.key.slice(0, item.key.length - 2) }}</span>
        <span class="value">{{ item.value }}</span>
      </li>
    </ul>
  </div>
</ng-container>
